import Vue from "vue";
import Router from "vue-router";
import store from '../store'

Vue.use(Router);

export const constantRoutes = [
    {
        path: "/",
        redirect: "/index",
        hidden: 0
    },
    {
        id: 0,
        path: '/login',
        name: "登录",
        component: () => process.env.VUE_APP_APP_HOST === 'gpt4' ? import('@/views/login/gpt4.vue') : import('@/views/login/login.vue'),
    },
    {
        id: 1,
        path: '',
        name: "",
        component: () => import('@/components/Layout.vue'),
        children: [{
            id: 101,
            path: '/index',
            name: "首页",
            component: () => import('@/views/home/index.vue'),
        },{
            id: 102,
            path: '/my',
            name: "账号中心",
            component: () => import('@/views/my/index.vue'),
        },{
            id: 103,
            path: '/chat',
            name: "会话",
            component: () => import('@/views/chat/index.vue'),
        },{
            id: 105,
            path: '/mychat',
            name: "历史对话",
            component: () => import('@/views/mychat/index.vue'),
        },
        {
            path: '/apis',
            name: "API定制",
            component: () => import('@/views/apis/index.vue'),
        }
    ]
    },
]
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)

}

const createRouter = () => new Router({
    mode: 'history', // require service support  这是干嘛用的下次查
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})
const router = createRouter()
/*
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next()
    } else {
        if (store.state.user.account) {
            store.dispatch('updateAccountAsync')
            next()
        } else {
            store.dispatch('updateAccountAsync', (success) => {
                if (success) {
                    next()
                } else {
                    next('/login')
                }
            })
        }
    }
})
*/
export default router;
